<template>
  <Card variant="outline" size="medium" class="empty-state">
    <View direction="column" gap="sm" align="start">
      <IconTile v-if="icon" :icon="icon" :color="color" colored-icon shape="rounded" size="small" />
      <Text variant="h4">{{ title }}</Text>
      <Text v-if="description" variant="body-medium" color="secondary">{{ description }}</Text>
      <div v-if="$slots.action" class="empty-state__action">
        <slot name="action" />
      </div>
    </View>
  </Card>
</template>

<script setup lang="ts">
import type { IconName } from '../values/icons.const';
import Card from './card/card.vue';
import type { IconTileColor } from './icon-tile/icon-tile.props';
import IconTile from './icon-tile/icon-tile.vue';
import Text from './text.vue';
import View from './view/view.vue';

withDefaults(
  defineProps<{
    title: string;
    description?: string;
    icon?: IconName;
    // Tint of the icon tile — echoes the activity-feed icon language. Defaults to neutral.
    color?: IconTileColor;
  }>(),
  { color: 'neutral' },
);
</script>

<style scoped lang="scss">
.empty-state {
  max-width: 32rem;
}

.empty-state__action {
  margin-top: var(--t-spacing-xs);
}
</style>
